// eslint-disable-next-line import/prefer-default-export
export const buildMutedState = ({ isFeatureEnabled, isLocked, panelKey, mutedDisabledPanels = [] }) => {
  const isPanelMuted = Boolean(isFeatureEnabled) && Boolean(isLocked);
  const isCardMuteDisabled = panelKey ? mutedDisabledPanels.includes(panelKey) : false;
  return isPanelMuted && !isCardMuteDisabled;
};
